export default __webpack_public_path__ + "static/media/selected9.bc4afea0.png";